export function getFileExtension(url) {
    const parts = url.split('.');
    const extension = parts.length > 1 ? parts[parts.length - 1] : undefined;
    return extension || null;
}
